export const NUMBER_DAYS_IN_MONTH = 30;
export const MONTHS_IN_YEAR = 12;
export const DAYS_IN_YEAR = NUMBER_DAYS_IN_MONTH * MONTHS_IN_YEAR;
export const MIN_YEARS = 0;
export const MAX_YEARS = 20;
export const YEARS_STEP = 0.5;
export const MIN_MONTHS = 0;
export const MAX_MONTHS = 60;
export const MONTHS_STEP = 1;
